import { useQuery } from "@tanstack/react-query";
import { fetchAppBranding } from "../services/appBrandService";

export function useAppBranding() {
  return useQuery({
    queryKey: ["appBranding"],
    queryFn: fetchAppBranding,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) => previousData ?? null,
  });
}
